import react, { useEffect, useState } from 'react'
import { APIIcon, ArrowIcon, CrownActive, CrownDisabled, Logo, ScanIcon, BritishizerIcon, StatisticIcon, DoubleChevronIcon, SmallLogoIcon } from '../icons'
import {appRouter} from '../../router';
import './style.css'
import { Avatar } from '../avatar';
import { ProgressBar } from '../progressBar';
import { formatBigNumbers } from '../currentPlan';
import { useNavigate } from 'react-router-dom';
import {logEvent, useUser} from "utils";
import 'tippy.js/dist/tippy.css';
import { OnboardingTooltip } from 'elements/tooltip';
import {INVISIBLE_ID} from "../../stores/onboarding";
import {observer} from "mobx-react-lite";

const ChevronButton: React.FC<{active: boolean, onClick: () => void}> = ({active, onClick}) => {
    return (
        <div className={'rotated chevron-button ' + (!active ? "rotated-back chevron-button__active" : "")} onClick={onClick}>
            <DoubleChevronIcon />
        </div>
    )
}

const iconsSlots = {
    'scan': (active: boolean) => <ScanIcon active={active}/>,
    'api': (active: boolean) => <APIIcon active={active}/>,
    'subscription': (active: boolean) => <>{active ? <CrownActive/> : <CrownDisabled />}</>,
    'britishizer': (active: boolean) => <BritishizerIcon active={active}/>,
    'statistics': (active: boolean) => <StatisticIcon active={active}/>
}

interface ISlot{
    active: boolean;
    onClick: (id: string) => void;
    children: react.ReactNode | string;
    id: string;
    isApi?: boolean;
    onboardingId?: number;
}

const Slot: react.FC<ISlot & {sidebarOpen: boolean}> = (props) => {
    var active = false;
    var link = props.id;
    var id = props.id;
    if (id.split('/').length > 1) {
        id = id.split('/')[1];
    }
    var pathname = window.location.pathname.split('/');
    if (props.active || 
        pathname[pathname.length-1] === id ||
        (
            props.id === 'api' && window.location.pathname.includes('api')
        )
    ) {
        active = true;
    }
    if (props.id === 'api') {
        link = 'api/table'
    }

    var iconWidget = <div></div>;
    try {
        iconWidget = (iconsSlots as any)[props.id](active)
    } catch {};

    var location = window.location.pathname.split('/');
    var available = false;
    if (location.includes('api')) {
        available = true;
    }

    return <OnboardingTooltip id={props.onboardingId ? props.onboardingId : INVISIBLE_ID}>
    <div 
            className={
                'slot__container' + 
                (
                    active ? "" : " slot__disabled"  
                ) + 
                (
                    props.isApi ? " slot__api" : ""
                ) +
                (
                    props.isApi && active ? " slot-api__active " : ""
                )
            } 
            id={props.id} 
            onClick={() => {
                props.onClick(props.id);
                appRouter.navigate('/main/'+link)
            }}
        >
        {
            iconWidget
        }
        {
            props.sidebarOpen ?
                <span className={'slot__text' + (active ? "" : " slot__text__disabled")}>
            {
                props.children === 'API' ?
                <div className='api__sidebar'>
                    <span>API</span>
                    <div className={'rotated ' + (available ? "rotated-back" : "")}>
                        <ArrowIcon />
                    </div>
                </div> :
                props.children
                    }
                </span>
            : <></>
        }
    </div>
    </OnboardingTooltip>
}



export const Sidebar: react.FC = observer(() => {
    const navigate = useNavigate();
    const user = useUser()
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);


    const slotChangeFunction = (id: string) => {
        logEvent("tab__" + id.replace("/", "_"))
        setSlots(slots.map((e) => {
            return e.id !== id ?
            e :
            {
                ...e,
                active: true
            }
        }));
    }
    const [slots, setSlots] = react.useState([
        {
            active: false,
            onClick: slotChangeFunction,
            id: 'scan',
            children: "Scan",
        },
        {
            active: false,
            onClick: slotChangeFunction,
            id: 'britishizer',
            children: "Britishizer",
            onboardingId: 4
        },
        {
            active: false,
            onClick: slotChangeFunction,
            id: 'subscription',
            children: 'Subscription',
            isApi: false
        },
        {
            active: false,
            onClick: slotChangeFunction,
            id: 'statistics',
            children: "Statistics",
            isApi: false,
            onboardingId: 5
        },
        {
            active: false,
            onClick: slotChangeFunction,
            id: 'api',
            children: "API",
            onboardingId: 6
        },
        {
            active: false,
            onClick: slotChangeFunction,
            id: 'api/table',
            children: "Keys",
            isApi: true,
        },
        {
            active: false,
            onClick: slotChangeFunction,
            id: 'api/docs',
            children: "Docs",
            isApi: true
        },
    ]);

    useEffect(() => {
        const updateSidebar = () => {
            const currentPath = window.location.pathname.split('/').pop() || 'scan';
            setSlots(prevSlots => prevSlots.map(slot => ({
                ...slot,
                active: slot.id === currentPath || (currentPath === 'table' && slot.id === 'api/table')
            })));
        };

        updateSidebar();
    }, [navigate, setSlots]);

    useEffect(() => {
        const updateParentWidth = () => {
            const rootElement = document.documentElement;
            const parentWidth = isSidebarOpen 
                ? 'calc(100vw - 298px - 400px - 60px)'
                : 'calc(100vw - 56px - 440px - 18px)';
                
            rootElement.style.setProperty('--parent-width', parentWidth);
            
            const allElements = document.querySelectorAll('*');
            allElements.forEach(element => {
                (element as HTMLElement).style.setProperty('--parent-width', parentWidth);
            });
        };

        updateParentWidth();
    }, [isSidebarOpen, slots]);

    var location = window.location.pathname.split('/');
    var available = false;
    if (location.includes('api')) {
        available = true;
    }
    return <div className={'sidebar__container ' + (isSidebarOpen ? "" : "sidebar__container__closed")}>
        <ChevronButton active={isSidebarOpen} onClick={() => {
            setIsSidebarOpen(!isSidebarOpen);
        }}/>
        <div className={"sidebar__content " + (isSidebarOpen ? "" : "sidebar__content__closed")}>
            <div className="sidebar__content-content">
                <div onClick={() => {
                    slotChangeFunction("scan")
                    appRouter.navigate('/main/scan')
                }}
                    className={"logo__container-f " + (isSidebarOpen ? "" : "logo__container-f__closed")}>
                    {
                        isSidebarOpen ?
                            <Logo />
                        : <SmallLogoIcon color="black" size={36}/>
                    }
                </div>
                <div className="slots">
                    {
                        slots.filter((e) => {
                            return !e.isApi
                        }).map((e, i) => <Slot key={i} {...e} sidebarOpen={isSidebarOpen}/>)
                    }
                    {
                        available ?
                            <div className='slot__api-container' style={{display: isSidebarOpen ? 'block' : 'none'}}>
                                {
                                    slots.filter((e) => {
                                        return e.isApi
                                    }).map((e, i) => <Slot key={i} {...e} sidebarOpen={isSidebarOpen}/>)
                                }
                            </div> : <></>
                    }
                    
                </div>
            </div>
            <div className="sidebar__avatar">
                <Avatar sidebarOpen={isSidebarOpen}/>
                <div className="progress-sidebar__container">
                    {
                        isSidebarOpen ?
                            <>
                                <ProgressBar 
                                    progress={((user?.used_words_simple_scan || 0) / (user?.granted_words_simple_scan || 1)) * 100}
                                />
                                
                    <span className='sb__text'>
                                    <strong>{`${formatBigNumbers((user?.used_words_simple_scan || 0).toString())} out of ${formatBigNumbers((user?.granted_words_simple_scan || 0).toString())}`}</strong>
                                    <br/>
                                    words used
                                </span>
                            </>
                        : <></>
                    }
                </div>

            </div>
        </div>
    </div>
})